import script from "./currency-info-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./currency-info-box.vue?vue&type=script&setup=true&lang=ts"

import "./currency-info-box.vue?vue&type=style&index=0&id=38b689b8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b689b8"]])

export default __exports__